import { FlexContainer, Spinner } from '@taxdown/piccolo-web';
import { useFetchGetCustomers } from 'Containers/Plans/hooks';
import { FRONT_PLANS, plansNameMapping } from 'Constants/plans';
import * as Styled from './styles';
import Header from './components/Header';
import Dates from './components/Dates';
import ManageSubscription from './components/ManageSubscription';
import Services from './components/Services';

const AccountSubscription = (): JSX.Element => {
  const { isLoading: isLoadingSubscriptions, data } = useFetchGetCustomers(true);
  if (isLoadingSubscriptions && !data) {
    return <Spinner size="L" align="center" justify="center" />;
  }
  const activePlan = plansNameMapping(data?.activePlan?.name || '');
  return (
    <FlexContainer direction="column" gap="dimension_24">
      <Styled.Wrap $overflow>
        <FlexContainer direction="column" gap="dimension_08">
          {data && <Header subscription={data} />}
          {data && <Dates subscription={data} />}
        </FlexContainer>
      </Styled.Wrap>
      {activePlan !== FRONT_PLANS.FULL && data && <ManageSubscription subscription={data} />}
      {data && <Services subscription={data} />}
    </FlexContainer>
  );
};

export default AccountSubscription;
